function formatMoney(cents, format = "{{amount}}", { currency, locale } = {}) {
  const activeCurrency =
    currency ||
    (window.Shopify && Shopify.currency && Shopify.currency.active) ||
    "USD";

  const activeLocale =
    locale || document.documentElement.lang || navigator.language || "en-US";

  if (typeof cents === "string") cents = cents.replace(/[^0-9\-]/g, "");
  const intCents = Math.round(Number(cents));
  if (Number.isNaN(intCents))
    throw new TypeError("formatMoney: “cents” must be numeric");

  const ISO_ZERO_DEC = {
    BIF: 1,
    CLP: 1,
    DJF: 1,
    GNF: 1,
    JPY: 1,
    KMF: 1,
    KRW: 1,
    MGA: 1,
    PYG: 1,
    RWF: 1,
    VND: 1,
    VUV: 1,
    XAF: 1,
    XOF: 1,
    XPF: 1,
  };

  const amount = intCents / 100;
  const twoDigits = new Intl.NumberFormat(activeLocale, {
    style: "currency",
    currency: activeCurrency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);

  const noDigits = new Intl.NumberFormat(activeLocale, {
    style: "currency",
    currency: activeCurrency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);

  const swap = (str, from, to) =>
    str.replace(from, "\uFFFF").replace(to, from).replace("\uFFFF", to);

  const replacements = {
    amount: twoDigits,
    amount_no_decimals: noDigits,
    amount_with_comma_separator: swap(twoDigits, ".", ","),
    amount_no_decimals_with_comma_separator: swap(noDigits, ".", ","),
    amount_with_space_separator: swap(twoDigits, ",", " "), // thin‑space
    amount_no_decimals_with_space_separator: swap(noDigits, ",", " "),
  };

  const value =
    replacements[format] ||
    new Intl.NumberFormat(activeLocale, {
      style: "currency",
      currency: activeCurrency,
      minimumFractionDigits: ISO_ZERO_DEC[activeCurrency] ? 0 : 2,
    }).format(amount);

  return value;
}

window.Shopify = window.Shopify || {};
Shopify.formatMoney = function (cents, fmt) {
  return formatMoney(cents, fmt, {});
};